import { Button, Input } from "antd";
import { FC } from "react";
import { useIntl } from "react-intl";

interface DiscountProps {
  discount: {
    type: "fixed" | "percentage";
    value: number;
  };
  setDiscount: React.Dispatch<
    React.SetStateAction<{
      type: "fixed" | "percentage";
      value: number;
    }>
  >;
  totalPrice: number;
}

const Discount: FC<DiscountProps> = ({ discount, setDiscount, totalPrice }) => {
  const intl = useIntl();

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="">
        <span>{intl.formatMessage({ id: "additionalDiscount" })}</span>
      </div>
      <div className="w-[70%]">
        <Input
          type="number"
          max={discount?.type === "fixed" ? totalPrice : 100}
          prefix={
            <small className=" ">
              {discount?.type === "fixed"
                ? intl.formatMessage({ id: "SARshort", defaultMessage: "ر.س" })
                : "%"}
            </small>
          }
          suffix={
            <div className="flex gap-1 items-center">
              <Button
                type={discount?.type === "fixed" ? "primary" : "default"}
                htmlType="button"
                onClick={() => {
                  setDiscount({ type: "fixed", value: discount?.value || 0 });
                }}
                className="w-[50px]"
              >
                {intl.formatMessage({ id: "SARshort" })}
              </Button>
              <Button
                type={discount?.type === "percentage" ? "primary" : "default"}
                htmlType="button"
                onClick={() => {
                  setDiscount({
                    type: "percentage",
                    value: discount?.value > 100 ? 100 : discount?.value || 0,
                  });
                }}
                className="w-[50px]"
              >
                %{" "}
              </Button>
            </div>
          }
          className=" w-full "
          value={discount?.value}
          min={0}
          onChange={(e) => {
            let value = Number(e.target.value);
            if (discount?.type === "fixed") {
              if (+e?.target?.value > totalPrice) {
                value = totalPrice;
              }
            } else {
              if (+e?.target?.value > 100) {
                value = 100;
              }
            }
            setDiscount({
              type: discount?.type,
              value: value,
            });
          }}
        />
      </div>
    </div>
  );
};

export default Discount;
